"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMidnightFromString = exports.getHoursSafe = exports.getFormattedDuration = exports.getDateWithoutTimezone = exports.formatServerDate = exports.convertServerDateToClientDate = exports.convertDateToServerFormat = exports.SERVER_DATE_FORMAT = exports.CLIENT_DATE_FORMAT = void 0;

var _pickBy2 = _interopRequireDefault(require("lodash/pickBy"));

var _intervalToDuration = _interopRequireDefault(require("date-fns/intervalToDuration"));

var _format = _interopRequireDefault(require("date-fns/format"));

var _isValid = _interopRequireDefault(require("date-fns/isValid"));

var _date = require("@lt/components/utils/date");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var convertDateToServerFormat = function convertDateToServerFormat(date) {
  var mm = date.getMonth() + 1;
  var dd = date.getDate();
  var yyyy = date.getFullYear();
  return [yyyy, mm, dd].join('-');
};
/**
 * Вырезаем таймзону, чтобы показать местное время
 * @param {string} date 2018-12-26T10:00:00.000+03:00
 * @returns {string} 2018-12-26T10:00:00
 */


exports.convertDateToServerFormat = convertDateToServerFormat;

var getDateWithoutTimezone = function getDateWithoutTimezone(date) {
  var _date$split = date.split('.'),
      _date$split2 = _slicedToArray(_date$split, 1),
      dateWithoutTimezone = _date$split2[0];

  var parseDate = new Date(dateWithoutTimezone);
  var isValidDate = (0, _isValid["default"])(parseDate);
  return isValidDate ? dateWithoutTimezone : date;
};
/**
 * Возвращает время из даты безопасно, с фолбеком на текст
 * @param {string} date
 * @param {string} invalidText
 * @returns {string} HH:mm | Неизвестно
 */


exports.getDateWithoutTimezone = getDateWithoutTimezone;

var getHoursSafe = function getHoursSafe(date) {
  var invalidText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Неизвестно';
  var dateString = getDateWithoutTimezone(date);
  if (!dateString) return invalidText;
  var parseDate = new Date(dateString);
  return (0, _format["default"])(parseDate, 'HH:mm');
};
/**
 * Возвращает время в формате 1 д 2 ч 25 мин
 * @param {number} value seconds
 * @param {string} minuteSuffix суфикс
 * @returns {string}
 */


exports.getHoursSafe = getHoursSafe;

var getFormattedDuration = function getFormattedDuration(value) {
  var minuteSuffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'мин';
  var prepareDuration = (0, _intervalToDuration["default"])({
    start: 0,
    end: value * 1000
  });
  var duration = (0, _pickBy2["default"])(prepareDuration);
  var days = duration.days,
      hours = duration.hours,
      minutes = duration.minutes;
  var formattedDays = days ? "".concat(days, " \u0434 ") : '';
  var formattedHours = hours ? "".concat(hours, " \u0447 ") : '';
  var formattedMinutes = minutes ? "".concat(minutes, " ").concat(minuteSuffix) : '';
  return [formattedDays, formattedHours, formattedMinutes].join('');
};

exports.getFormattedDuration = getFormattedDuration;
var SERVER_DATE_FORMAT = 'yyyy-MM-dd';
exports.SERVER_DATE_FORMAT = SERVER_DATE_FORMAT;
var CLIENT_DATE_FORMAT = 'dd.MM.yyyy';
/**
 * Возвращает дату в формате 2019-03-16
 * @param {Date} date
 * @returns {string}
 */

exports.CLIENT_DATE_FORMAT = CLIENT_DATE_FORMAT;

var formatServerDate = function formatServerDate(date) {
  return (0, _date.formatDate)(date, SERVER_DATE_FORMAT);
};

exports.formatServerDate = formatServerDate;

var getMidnightFromString = function getMidnightFromString(date) {
  return new Date(date).setHours(0, 0, 0, 0);
};
/**
 * Конвертирует серверную дату YYYY-MM-DD в клиентскую DD.MM.YYYY
 * @param {string | Date} string YYYY-MM-DD
 * @returns {string} DD.MM.YYYY
 */


exports.getMidnightFromString = getMidnightFromString;

var convertServerDateToClientDate = function convertServerDateToClientDate(string) {
  return (0, _date.formatDate)(string, CLIENT_DATE_FORMAT);
};

exports.convertServerDateToClientDate = convertServerDateToClientDate;